var Component = require("!../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../node_modules/vue-loader/lib/selector?type=script&index=0!./boxes-wrapper-inclusion.vue"),
  /* template */
  require("!!../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-0bc0d41c\",\"hasScoped\":false}!../../node_modules/vue-loader/lib/selector?type=template&index=0!./boxes-wrapper-inclusion.vue"),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/boxes-wrapper-inclusion.vue
// module id = 87
// module chunks = 0